var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrop = function SvgCrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "crop_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#crop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 22v-3H7q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 17V7H2a.97.97 0 0 1-.712-.287A.97.97 0 0 1 1 6q0-.424.288-.713A.97.97 0 0 1 2 5h3V2q0-.424.287-.712A.97.97 0 0 1 6 1q.424 0 .713.288Q7 1.575 7 2v15h15q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 22 19h-3v3q0 .424-.288.712A.97.97 0 0 1 18 23a.97.97 0 0 1-.712-.288A.97.97 0 0 1 17 22m0-7V7H9V5h8q.824 0 1.413.588Q19 6.175 19 7v8z"
  }))));
};
export default SvgCrop;